import React, {useEffect, useState} from 'react';
import {useLocation, useParams} from 'react-router-dom';

export const Schedule = () => {

  const [pickUpType, setPickUpType] = useState("");
  const [containerCount, setContainerCount] = useState("");
  const [containerSize, setContainerSize] = useState("");
  const [pickUpFreq, setPickUpFreq] = useState("");
  const [pickUpDays, setPickUpDays] = useState("");
  const [hasDumpsterLock, setHasDumpsterLock] = useState(false);
  const [frontLoadRearLoad, setFrontLoadRearLoad] = useState("");
  const [hasSchedule, setHasSchedule] = useState(false);
  const [locationNameNumber, setLocationNameNumber] = useState("");
  const [address, setAddress] = useState("");
  const {state} = useLocation();
  const params = useParams();
  const id = state && state.id ? state.id : params.id;

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchSchedule();
  }, [])

  const fetchSchedule = async() => {
    const response = await fetch(`/apischedule/${id}`);
    const schedule = await response.json();
      // 66 = location number, 36 = address, 21 = location code, 
  // 20 = pick up type, 33 = container count, 15 container size, 
  // 16 = pick up freq., 61 = pick up days, 44 = has dumpster lock
  // 45 = frontRear
    const locationNameNumber = schedule && schedule[66] ? schedule[66].value : "";
    const containerCount = schedule && schedule[33] ? schedule[33].value : "";
    const address = schedule && schedule[36] ? schedule[36].value : "";
    const containerSize = schedule && schedule[15] ? schedule[15].value : "";
    const pickUpFreq = schedule && schedule[16] ? schedule[16].value : "";
    const pickUpDays = schedule && schedule[61] ? schedule[61].value : "";
    const frontRearLoad = schedule && schedule[45] ? schedule[45].value : "";
    const pickUpType = schedule && schedule[20] ? schedule[20].value : "";
    const hasDumpsterLock = schedule && schedule[44] ? schedule[44].value : false;
    setLocationNameNumber(locationNameNumber);
    setContainerCount(containerCount);
    setFrontLoadRearLoad(frontRearLoad);
    setAddress(address);
    setHasDumpsterLock(!!hasDumpsterLock);
    setPickUpDays(pickUpDays);
    setPickUpFreq(pickUpFreq);
    setPickUpType(pickUpType);
    setContainerSize(containerSize);
    setHasSchedule(true);
  }

  return (
    <div className="schedule detailPage">{hasSchedule && (<>
      <header className="detailHero"><div><span className="detailEyebrow">Waste &amp; recycling</span><h2>Service Schedule</h2><p>Pickup and container information for location {locationNameNumber || '—'}.</p></div><span className="detailAppBadge">Waste</span></header>
      <section className="detailCard scheduleDetailsWrapper">
        <div className="detailCardHeader"><div><h3>Schedule details</h3><p>Current recurring waste and recycling service information.</p></div></div>
        <div className="detailGrid">
          <div className="detailField"><span>Location number</span><strong>{locationNameNumber || '—'}</strong></div>
          <div className="detailField"><span>Address</span><strong>{address || '—'}</strong></div>
          <div className="detailField"><span>Pickup type</span><strong>{pickUpType || '—'}</strong></div>
          <div className="detailField"><span>Pickup frequency</span><strong>{pickUpFreq || '—'}</strong></div>
          <div className="detailField"><span>Pickup days</span><strong>{pickUpDays || '—'}</strong></div>
          <div className="detailField"><span>Container</span><strong>{[containerCount && `${containerCount} container${Number(containerCount) === 1 ? '' : 's'}`, containerSize].filter(Boolean).join(' · ') || '—'}</strong></div>
          <div className="detailField"><span>Load type</span><strong>{frontLoadRearLoad || '—'}</strong></div>
          <div className="detailField"><span>Dumpster lock</span><strong>{hasDumpsterLock ? 'Yes' : 'No'}</strong></div>
        </div>
      </section>
      </>
    )}</div>
  )
}
